import { InputValidity } from '@one/web-components';
import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { RowsPerPageAPI } from 'core/service/user-preferences/domain/api/row-per-page.api';
import { ViewFieldApi } from 'modules/global/api';
import { EditableColumn } from 'modules/global/model/editable-column.model';
import { SortFieldQuery } from 'modules/operators/pods/private-pods/operators-list/operators-sort/api/operators-sort.api.model';

export interface UserPreferencesApi<T = unknown> {
    userPreferencesId: string;
    rowsPerPage: RowsPerPageAPI;
    operatorReportHeader: string;
    filters: UserCustomFilterApi<T>[];
    language: {
        languageName: string;
    };
    viewFields: ViewFieldApi[];
}

export type ViewField = {
    viewFieldId?: string;
    viewType: string;
    viewId?: string;
    fields: EditableColumn[];
};

export interface UserCustomFilter<T> {
    id?: string;
    name: string;
    entity?: string;
    fields: T;
    sorting?: CustomTableSortItems;
}

export const UserCustomFilterTypes: Record<string, string> = {
    OPERATORS: 'OPERATORS',
    TRAINING_PROGRAMS: 'TRAINING_PROGRAMS',
    DEVICES: 'DEVICES',
};

export interface UserCustomFilterApi<T> {
    filterId?: string;
    filterName: string;
    type?: string;
    frontendData?: {
        filter?: T;
        sorting?: CustomTableSortItems | SortFieldQuery<T>;
    };
    queryData?: string;
}

export interface UserCustomFilterSaveValidation {
    name?: InputValidity;
}
